import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const createUser = async (user) => {
    Store.dispatch(loadingActions.loadingStart('profile.createUser'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/new', {
            "email": user.email,
            "name": user.name,
            "color": user.color,
            "password": user.password,
            "confirm": user.confirm
        });
        Store.dispatch(loadingActions.loadingEnd('profile.createUser'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.createUser'));
        return e.response.data;
    }
};

export const loginAs = async (email, password) => {
    Store.dispatch(loadingActions.loadingStart('profile.loginAs'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/login/credentials', {email, password});
        Store.dispatch(loadingActions.loadingEnd('profile.loginAs'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.loginAs'));
        return e.response.data;
    }
};

export const sendCode = async (email) => {
    Store.dispatch(loadingActions.loadingStart('profile.sendCode'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/login/forgot', {email});
        Store.dispatch(loadingActions.loadingEnd('profile.sendCode'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.sendCode'));
        return e.response.data;
    }
};

export const resetPassword = async (email, code, password, confirm) => {
    Store.dispatch(loadingActions.loadingStart('profile.resetPassword'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/login/reset', {email, code, password, confirm});
        Store.dispatch(loadingActions.loadingEnd('profile.resetPassword'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.resetPassword'));
        return e.response.data;
    }
};

export const getStatus = async () => {
    Store.dispatch(loadingActions.loadingStart('profile.getStatus'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/profile/status');
        Store.dispatch(loadingActions.loadingEnd('profile.getStatus'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.getStatus'));
        return e.response.data;
    }
};

export const getMyProfile = async () => {
    Store.dispatch(loadingActions.loadingStart('profile.getMyProfile'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/profile/me');
        Store.dispatch(loadingActions.loadingEnd('profile.getMyProfile'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.getMyProfile'));
        return e.response.data;
    }
};

export const editProfile = async (data) => {
    Store.dispatch(loadingActions.loadingStart('profile.edit'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/profile/edit', data);
        Store.dispatch(loadingActions.loadingEnd('profile.edit'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.edit'));
        return e.response.data;
    }
};

export const editPassword = async (password, current, confirm) => {
    Store.dispatch(loadingActions.loadingStart('profile.editPassword'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/profile/pass', {password, current, confirm});
        Store.dispatch(loadingActions.loadingEnd('profile.editPassword'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('profile.editPassword'));
        return e.response.data;
    }
};